export default {
  name: 'Call to action section - 4',
  tab: 'call to action',
  type: 'content-default-section',
  content: {
    title: 'Call to action',
    introtext:
      '<p>Aenean lacinia bibendum nulla sed consectetur. Sed posuere consectetur est at lobortis. Etiam porta sem malesuada magna mollis euismod. Morbi leo risus, porta ac consectetur ac.</p>',
    image: '',
    buttons:
      '[{"button-text":"Call to action","button-link":"#section-1","button-style":"default","button-background-color":"var(--accent-color)","button-text-color":"var(--secondary-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image':
      '/storage/media/samples/ian-dooley-TevqnfbI0Zc-unsplash.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h3',
    'introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'center',
    'content-box': '1',
    'content-box-color': 'var(--primary-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '0.8',
    'content-box-elevation': '8',
    'content-box-border': '0',
    'content-box-border-color': 'var(--text-dark-color)',
    'content-box-rounded': '1'
  },
  advanced: {}
}
